import instance from "../axios";
import { getUserToken } from "./userAuthenticate";

// load templates from api
export const loadTemplatesData=async()=>{
    try{
      const url = "/giftcard/products/templates/get"
      const headers = {
        Authorization: getUserToken(),
      }
      const res = await instance.post(url, {}, { headers });
      const data = await res.data;  
      return data
    }
    catch(e){
      return {success: false, message: e.message, data: ""}
    }
}

export const addTemplateToDb=async(img_url, category="")=>{
  try{
    const url = "/giftcard/products/templates/add"
    const headers = {
      Authorization: getUserToken(),
    }
    const payload = [{
      attachment: img_url,
      category
    }]
    const res = await instance.post(url, {templates: payload}, { headers });
    const data = await res.data;
    return data
  }
  catch(e){
    return {success: false, message: e.message, data: ""}
  }
}

export const createNewCategory=async(category)=>{
    try{
        const url = "/giftcard/products/templates/add-category"
        const headers = {
            Authorization: getUserToken(),
        }
        const payload = {
            newCategory: category
        }
        const res = await instance.post(url, payload, {headers})
        const data = await res.data
        return data
    } catch(e) {
        return {success: false, message: e.message, data: ""}
    }
}

export const addCoverImageInCategory=async(coverImgBase64, category)=>{
    try{
        const url = "/giftcard/products/templates/add-category-cover"
        const headers = {
            Authorization: getUserToken(),
        }
        const payload = {
            category,
            coverImages: [coverImgBase64]
        }
        const res = await instance.post(url, payload, {headers})
        const data = await res.data
        return data
    } catch(e) {
        return {success: false, message: e.message, data: ""}
    }
}
export const removeCategory=async(item)=>{
  try{
    const url = "/mail-template/category/delete"
        const headers = {
            Authorization: getUserToken(),
        }
        const payload = {
          categoryName: item.category
        }
        const res = await instance.post(url, payload, {headers})
        const data = await res.data
        return data
  }
  catch(e){
    return {success: false, message: e.message, data: ""}
  }
}